import React, { useCallback, useEffect, useRef, useState } from "react";
import "./messages.css";
import { useDispatch, useSelector } from "react-redux";
import {
  initiateCall,
  msgPhoneEmailDetail,
  postOrder,
  sendMessage,
} from "../../../components/Header/Data";
import { toast } from "react-toastify";
import "./Styles/InputBox.css";
import { LiaPhoneAltSolid } from "react-icons/lia";
import { IoMdAttach } from "react-icons/io";
import { IoSend } from "react-icons/io5";
import {
  FaDollarSign,
  FaFilePdf,
  FaImage,
  FaVideo,
  FaUser,
  FaRegClock,
  FaSmile,
} from "react-icons/fa";
import { MdGroups } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import uploadToS3 from "../../../utils/awsS3Upload";

import Payment from "../settingsComponents/Payment";
import { useSocket } from "../../../contexts/SocketContext";
import ThankYouModal from "../Orders/ThankYouPage";
import MsgScheduleModal from "../../../components/Header/modals/MsgScheduleModal";
import { Tooltip } from "@mui/material";
import {
  Button,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  Spinner,
} from "reactstrap";
import {
  addIncomingMessage,
  setDescription,
  setMessages,
  setMessageText,
  setOrder,
  setOrderStatus,
  setSelectedConversation,
  setSelectedFile,
  setSendingFile,
  setSendingMsg,
} from "../../../redux/slices/MsgSlice";

import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { debounce } from "lodash";

function MsgInputBox({ isChatModal, isAds }) {
  const [showAttachOptions, setShowAttachOptions] = useState(false);
  const [showCallOptions, setShowCallOptions] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const attachOptionsRef = useRef(null); // Reference for attach-options
  const callOptionsRef = useRef(null); // Reference for call-options
  const emojiPickerRef = useRef(null); // Reference for emoji-picker
  const [twilioDetails, setTwilioDetails] = useState({});
  const { sendNewMessage, onMessageReceived, handleTyping, socket } =
    useSocket();
  const {
    messageText,
    description,
    order,
    orderStatus,
    sendingMsg,
    selectedConvo,
    addOptimisticMessage,
    typingStatus,
  } = useSelector((state) => state.messages);
  const selectedFile = useSelector((state) => state.messages.selectedFile);
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isAdmin = user && user.Role === "admin"; // Check if user is admin
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [amount, setAmount] = useState(null);
  const [openPaypal, setOpenPaypal] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const { sampleAd, isChatModalOpen } = useSelector((state) => state.searchBar);
  const typingTimeoutRef = useRef(null);

  const emitTyping = useCallback(() => {
    if (!selectedConvo?.Id || !user?.UserID) return;

    socket.emit("typing", {
      userId: user.UserID,
      convoId: selectedConvo.Id,
      stop: false, // Explicitly typing
    });
  }, [user?.UserID, selectedConvo?.Id, socket]);

  const debouncedEmitTyping = useCallback(debounce(emitTyping, 500), [
    emitTyping,
  ]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend(e, "user");
      return;
    }

    debouncedEmitTyping();

    // Clear on stop typing after 1s
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    typingTimeoutRef.current = setTimeout(() => {
      socket.emit("typing", {
        userId: user.UserID,
        convoId: selectedConvo?.Id,
        stop: true, // Send stop signal
      });
    }, 1000);
  };

  const handleBlur = () => {
    socket.emit("typing", {
      userId: user.UserID,
      convoId: selectedConvo?.Id,
      stop: true,
    });
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
  };

  const toggleModal = () => {
    setThankYou(false);
  };
  const handleModalClick = () => {
    setModalIsOpen(true);
  };
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
    // setOpenPaypal(false);
  };
  const closeModal = () => {
    setModalIsOpen(false);
    setAmount(null);
    setOpenPaypal(false);
    dispatch(setDescription(""));
  };

  const handlePayment = async () => {
    if (!description) {
      toast.error("Please Enter Description");
      return;
    }
    if (!amount) {
      toast.error("Please Enter Amount");
      return;
    }

    dispatch(setSendingMsg(true)); // Indicate payment processing

    let formData = {
      customerId: selectedConvo
        ? selectedConvo.customerId === user?.UserID
          ? selectedConvo.createdBy
          : selectedConvo.customerId || sampleAd.createdBy || sampleAd.vendorId
        : sampleAd.createdBy || sampleAd.vendorId,
      createdBy: user?.UserID,
      parentId: selectedConvo
        ? selectedConvo.parentId === 0
          ? selectedConvo.Id
          : selectedConvo.parentId
        : 0,
      totalAmount: amount,
      Message: description,
      orderType: 3,
      receiverId:
        selectedConvo?.createdBy === user?.UserID
          ? selectedConvo?.customerId
          : user?.UserID,
      messageId: selectedConvo?.Id,
      ownerId: selectedConvo?.ownerId,
      Description: `payment for chat with ${description}, ${amount}, PENDING`,
      orderStatus: "PENDING",
      Type: "chatpayment",
    };
    const order = await postOrder(formData);
    toast.success("Order Created and Message Sent");
    setOpenPaypal(true);
    dispatch(setOrder(order?.Id));
    try {
      if (order && order?.Id) {
        const messageForm = {
          customerId: selectedConvo
            ? selectedConvo.customerId === user?.UserID
              ? selectedConvo.createdBy
              : selectedConvo.customerId ||
                sampleAd.createdBy ||
                sampleAd.vendorId
            : sampleAd.createdBy || sampleAd.vendorId,
          postId: selectedConvo.postId || sampleAd?.post_id,
          postType: 1, // message 1 or requestQuote 2 or offer my service 3
          parentId:
            selectedConvo.parentId === 0
              ? selectedConvo.Id
              : selectedConvo.parentId,
          Description: `payment for chat with ${description}, ${amount}, PENDING`,
          messageStatus: 8,
          createdBy: user.UserID,
          roleId: user.RoleId,
          ownerId: selectedConvo.ownerId,
          userName: user.UserName.split("@")[0].trim(),
          Email: user.Email,
          serviceNeed: "need",
          needName: selectedConvo.postName,
          orderStatus: "PENDING",
          orderId: order?.Id,
          orderMessage: description,
          totalAmount: amount,
          orderType: 3,
          serviceNeed: "text",
        };
        const response = await sendMessage(messageForm);
        if (response.Data) {
          sendNewMessage(response.Data); // Send the actual message data via WebSocket
          dispatch(addIncomingMessage(response.Data)); // Add to local state immediately
        }
      }
    } catch (error) {
      console.error("Error handling payment:", error);
      toast.error("Payment and message failed. Please try again.");
      // dispatch(removeOptimisticMessage(tempMessageId)); // Revert optimistic update
    } finally {
      dispatch(setSendingMsg(false)); // Always stop spinner
    }
  };

  useEffect(() => {
    if (orderStatus === "COMPLETED") {
      setAmount(null);
      dispatch(setDescription(""));
      setModalIsOpen(false);
      setOpenPaypal(false);
      setThankYou(true);
      dispatch(setOrderStatus(""));
    }
  }, [orderStatus]);
  const handleSend = async (e, userType) => {
    if (!messageText.trim()) {
      toast.error("Please type something");
      return;
    }
    console.log(selectedConvo, "selectedConvo");
    console.log(sampleAd, "selectedConvo");
    dispatch(setSendingMsg(true));
    if (messageText.trim()) {
      const messageForm = {
        customerId: selectedConvo
          ? selectedConvo.customerId === user?.UserID
            ? selectedConvo.createdBy
            : selectedConvo.customerId ||
              sampleAd.createdBy ||
              sampleAd.vendorId
          : sampleAd.createdBy || sampleAd.vendorId,
        postId: selectedConvo?.postId ?? sampleAd.post_id,
        postType: 1, // message 1 or requestQuote 2 or offer my service 3
        parentId: selectedConvo
          ? selectedConvo.parentId === 0
            ? selectedConvo.Id
            : selectedConvo.parentId
          : 0,
        Description: messageText,
        messageStatus: userType === "user" ? 8 : 13,
        createdBy: userType === "user" ? user.UserID : selectedConvo?.createdBy,
        roleId: user?.RoleId,
        ownerId: selectedConvo?.ownerId ?? sampleAd.createdBy,
        userName:
          userType === "user"
            ? user.UserName.split("@")[0].trim()
            : selectedConvo?.senderName,
        Email: user.Email,
        serviceNeed:
          sampleAd && sampleAd.listName
            ? "service"
            : sampleAd?.Title
            ? "need"
            : "text",
        needName: selectedConvo
          ? selectedConvo.postName
          : sampleAd?.Title || "Title",
      };

      if (!messageText.trim()) {
        toast.error("Enter Message");
        return;
      }
      try {
        const response = await sendMessage(messageForm);
        if (response.Data) {
          sendNewMessage(response.Data); // Send the actual message data via WebSocket
          dispatch(addIncomingMessage(response.Data)); // Add to local state immediately
          dispatch(setMessageText(""));
          toast.success("Message Sent");
        }
      } catch (error) {
        console.error("Error sending message:", error);
        toast.error("Failed to send message. Please try again.");
      } finally {
        dispatch(setSendingMsg(false)); // Always stop spinner
      }
    }
  };
  const handleClick = (e) => {
    const offerAmount =
      selectedConvo.finalBudget !== null ? selectedConvo.finalBudget : 0;
    e.stopPropagation();
    if (islogin) {
      navigate("/order-summary", {
        state: {
          selectedConvo,
          offerAmount,
        },
      });
    } else {
      navigate("/login");
      toast.info("Please Login");
    }
  };
  const fetchMsgPhoneEmailDetail = debounce(async () => {
    if (selectedConvo && selectedConvo?.Id !== twilioDetails?.message_id) {
      const responseDetail = await msgPhoneEmailDetail(selectedConvo?.Id);
      setTwilioDetails(responseDetail[0] || {});
    }
  }, 300);
  useEffect(() => {
    fetchMsgPhoneEmailDetail();
    return () => fetchMsgPhoneEmailDetail.cancel(); // Cleanup debounce on unmount
  }, [selectedConvo]);
  const handleGroupCall = async (e) => {
    e.stopPropagation();
    const phoneDetailsObj = [
      {
        phoneNumber: twilioDetails?.created_by_phone || "",
        countryCode: twilioDetails?.created_by_phone
          ? twilioDetails?.created_country_code
          : "",
      },
      {
        phoneNumber: twilioDetails?.receiver_phone || "",
        countryCode: twilioDetails?.receiver_phone
          ? twilioDetails?.receiver_country_code
          : "",
      },
      {
        phoneNumber: twilioDetails?.alternative_phone_one || "",
        countryCode: twilioDetails?.alternative_phone_one
          ? twilioDetails?.receiver_country_code
          : "",
      },
      {
        phoneNumber: twilioDetails?.alternative_phone_two || "",
        countryCode: twilioDetails?.alternative_phone_two
          ? twilioDetails?.receiver_country_code
          : "",
      },
    ];
    if (
      twilioDetails?.Phone &&
      twilioDetails?.receiver_phone !== twilioDetails?.Phone
    ) {
      phoneDetailsObj.push({
        phoneNumber: twilioDetails?.Phone,
        countryCode: twilioDetails?.Phone
          ? twilioDetails?.receiver_country_code
          : "",
      });
    }
    // Filter out empty phone numbers
    const validPhoneDetails = phoneDetailsObj.filter(
      (detail) => detail.phoneNumber && detail.phoneNumber !== ""
    );
    const phoneDetails = JSON.stringify(validPhoneDetails);
    let formData = {
      phoneDetails: phoneDetails,
      email: selectedConvo?.senderEmail,
      userTo:
        selectedConvo?.customerId === user?.UserID
          ? selectedConvo?.createdBy
          : selectedConvo?.customerId,
      userFrom:
        selectedConvo?.createdBy === user?.UserID
          ? selectedConvo?.createdBy
          : selectedConvo?.customerId,
      callType: 1, // 1 for phone, 2 for voip, 3 for zoom
      userToPhone: phoneDetails,
      userFromPhone: `${user?.CountryCode}${user?.Phone}`,
      typeId: selectedConvo?.Id,
      Type: "messages",
    };
    toast.success(
      "Call be sent to your mobile device, Please answer the incoming call"
    ); // No await
    await initiateCall(formData);
  };

  const handleIndiviualCall = async (e) => {
    e.stopPropagation();
    const phoneDetailsObj = [
      {
        phoneNumber: twilioDetails?.created_by_phone || "",
        countryCode: twilioDetails?.created_by_phone
          ? twilioDetails?.created_country_code
          : "",
      },
      {
        phoneNumber: twilioDetails?.receiver_phone || "",
        countryCode: twilioDetails?.receiver_phone
          ? twilioDetails?.receiver_country_code
          : "",
      },
    ];
    const phoneDetails = JSON.stringify(phoneDetailsObj);
    let formData = {
      phoneDetails: phoneDetails,
      email: selectedConvo?.senderEmail,
      userTo:
        selectedConvo?.customerId === user?.UserID
          ? selectedConvo?.createdBy
          : selectedConvo?.customerId,

      userFrom:
        selectedConvo?.createdBy === user?.UserID
          ? selectedConvo?.createdBy
          : selectedConvo?.customerId,
      callType: 1, //1 for phone,2 for voip,3 for zoom
      userToPhone: phoneDetails,
      userFromPhone: `${user?.CountryCode}${user?.Phone}`,
      typeId: selectedConvo?.Id,
      Type: "messages",
    };
    toast.success("Call Started. Calling your phone Now"); // No await
    await initiateCall(formData);
  };

  const handleAttach = (e) => {
    e.stopPropagation();
    setShowAttachOptions(!showAttachOptions);
    if (showCallOptions) {
      setShowCallOptions(false); // Close call options if they are open
    }
    if (showEmojiPicker) {
      setShowEmojiPicker(false); // Close emoji picker if it is open
    }
  };

  const handleCallOptions = (e) => {
    e.stopPropagation();
    setShowCallOptions(!showCallOptions);
    if (showAttachOptions) {
      setShowAttachOptions(false); // Close attach options if they are open
    }
    if (showEmojiPicker) {
      setShowEmojiPicker(false); // Close emoji picker if it is open
    }
  };

  const handleEmojiClick = (e) => {
    e.stopPropagation();
    setShowEmojiPicker(!showEmojiPicker);
    if (showAttachOptions) {
      setShowAttachOptions(false); // Close attach options if they are open
    }
    if (showCallOptions) {
      setShowCallOptions(false); // Close call options if they are open
    }
  };

  const handleEmojiSelect = (emoji) => {
    dispatch(setMessageText(messageText + emoji.native));
  };

  const handleFileChange = (e) => {
    e.stopPropagation();
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        // Changed to 5MB from 250MB (was likely a typo)
        toast.error("File size must be less than 5MB.");
        dispatch(setSelectedFile(null));
        return;
      }
      dispatch(setSelectedFile(file));
      setShowAttachOptions(false);
    }
  };

  const handleFileSend = async () => {
    if (!selectedFile) {
      toast.error("Please select a file");
      return;
    }
    dispatch(setSendingFile(true)); // Start file sending spinner
    let fileUrl = await uploadToS3(
      selectedFile,
      `attachment-files/chat-${selectedConvo?.Id || "general"}`
    );
    let messageForm;
    if (selectedConvo) {
      messageForm = {
        customerId: selectedConvo
          ? selectedConvo.customerId === user?.UserID
            ? selectedConvo.createdBy
            : selectedConvo.customerId ||
              sampleAd.createdBy ||
              sampleAd.vendorId
          : sampleAd.createdBy || sampleAd.vendorId,
        postId: selectedConvo.postId,
        postType: 4, // message 1 , requestQuote 2 , offer my service 3 , Attachment 4
        parentId:
          selectedConvo.parentId === 0
            ? selectedConvo.Id
            : selectedConvo.parentId,
        Description: "Attachment",
        messageStatus: 8,
        createdBy: user.UserID,
        roleId: user.RoleId,
        ownerId: selectedConvo.ownerId,
        userName: user.UserName.split("@")[0].trim(),
        Email: user.Email,
        serviceNeed: "text",
        needName: selectedConvo.postName || "Text message",
        Photo: fileUrl || "",
      };
      // dispatch(addOptimisticMessage(optimisticMessage)); // You need to implement this action
      const response = await sendMessage(messageForm);
      if (response.Data) {
        sendNewMessage(response.Data); // Send the actual message data via WebSocket
        dispatch(addIncomingMessage(response.Data));
        toast.success("Attachment Sent"); // No await
        if (!selectedConvo && response.Data.parentId === 0) {
          dispatch(setSelectedConversation(response.Data));
        }
      } else {
        toast.error("Failed to send attachment.");
      }
      dispatch(setSendingFile(false));
      dispatch(setSelectedFile(null));
      setShowAttachOptions(false);
    } else {
      messageForm = {
        customerId: sampleAd.createdBy || sampleAd.vendorId,
        postId: sampleAd?.Id || sampleAd?.post_id,
        postType: 4, // message 1 or requestQuote 2 or offer my service 3
        Description: selectedFile.name,
        messageStatus: 8,
        createdBy: user.UserID,
        roleId: user.RoleId,
        ownerId: sampleAd.createdBy || sampleAd.vendorId || `0`,
        userName: user.UserName.split("@")[0].trim(),
        Email: user.Email,
        serviceNeed: "text",
        needName: sampleAd?.Title || sampleAd?.image_title || "Text message",
      };
      const response = await sendMessage(messageForm);
      if (response.Data) {
        let data = response.Data;
        if (data) {
          sendNewMessage(response.Data);
          dispatch(addIncomingMessage(response.Data));
          toast.success("Attachment Sent Successfully");
        }
        if (data.parentId == 0) {
          dispatch(setSelectedConversation(data));
        }
        dispatch(setMessageText(""));
        toast.success("Message Sent");
        sendNewMessage(response.Data);
        dispatch(addIncomingMessage(response.Data));
      }
      dispatch(setSelectedFile(null));
      setShowAttachOptions(false);
      dispatch(setSendingFile(false));
    }
  };
  React.useEffect(() => {
    if (selectedFile) {
      handleFileSend();
    }
  }, [selectedFile]); // Dependency on selectedFile is correct for auto-sending

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        attachOptionsRef.current &&
        !attachOptionsRef.current.contains(event.target)
      ) {
        setShowAttachOptions(false);
      }
      if (
        callOptionsRef.current &&
        !callOptionsRef.current.contains(event.target)
      ) {
        setShowCallOptions(false);
      }
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="input-box">
      <div className="input-box-icons">
        <Tooltip title="Schedule Message" placement="top" arrow>
          <span onClick={(e) => setScheduleModal(true)}>
            <FaRegClock />
          </span>
        </Tooltip>
        <MsgScheduleModal
          open={scheduleModal}
          close={() => setScheduleModal(false)}
          msg={selectedConvo}
          isChatModal={isChatModal}
        />
        <Tooltip title="Pay Amount" placement="top" arrow>
          <span onClick={handleModalClick}>
            <FaDollarSign />
          </span>
        </Tooltip>
        <Tooltip title="Insert Emoji" placement="top" arrow>
          <span onClick={handleEmojiClick}>
            <FaSmile />
          </span>
        </Tooltip>
        {showEmojiPicker && (
          <div
            className="emoji-picker"
            ref={emojiPickerRef}
            style={{
              position: "absolute",
              bottom: "50px",
              left: "100px",
              zIndex: 1000,
            }}
          >
            <Picker data={data} onEmojiSelect={handleEmojiSelect} />
          </div>
        )}
        <Modal isOpen={modalIsOpen} toggle={closeModal}>
          <ModalBody>
            <div>
              <Label>
                Description <b className="text-danger">*</b>
              </Label>
              <Input
                type="textarea"
                name="descrption"
                placeholder="Please Enter Descrption"
                value={description}
                onChange={(e) => dispatch(setDescription(e.target.value))}
              />
            </div>
            <div>
              <Label>Amount</Label>
              <InputGroup>
                <InputGroupText className="fw-bold">$</InputGroupText>
                <Input
                  type="number"
                  name="amount"
                  placeholder="amount"
                  value={amount}
                  onChange={handleAmountChange}
                />
              </InputGroup>
              <div>
                {!openPaypal ? (
                  <div className="text-center my-3">
                    <Button
                      color="primary"
                      onClick={handlePayment}
                      disabled={
                        parseInt(amount) <= 0 ||
                        amount === null ||
                        amount === "" ||
                        sendingMsg // Disable if sending msg
                      }
                    >
                      {sendingMsg ? <Spinner size="sm" /> : "Pay Now"}
                    </Button>
                  </div>
                ) : (
                  <Payment
                    totalPrice={Number(amount)}
                    state={{ chatPay: true }}
                    chatDetails={true}
                  />
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Tooltip title="Create Call" placement="top" arrow>
          <span onClick={(e) => handleCallOptions(e)}>
            <LiaPhoneAltSolid />
          </span>
        </Tooltip>
        {showCallOptions && (
          <div
            className="attach-options"
            style={{ width: "150px", left: "3px", padding: "7px" }}
            ref={callOptionsRef}
          >
            <label>
              <div
                className="  call-inbox"
                onClick={(e) => handleIndiviualCall(e)}
              >
                <FaUser /> Individual Call
              </div>
            </label>
            <label>
              <div className="  call-inbox" onClick={(e) => handleGroupCall(e)}>
                <MdGroups size={20} /> Group Call
              </div>
            </label>
          </div>
        )}
        <Tooltip title="Attach File" placement="top" arrow>
          <span onClick={(e) => handleAttach(e)}>
            <IoMdAttach />
          </span>
        </Tooltip>
      </div>

      {showAttachOptions && (
        <div className="attach-options" ref={attachOptionsRef}>
          <label>
            <input
              type="file"
              name="image"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            Photo <FaImage />
          </label>
          <label>
            <input
              type="file"
              name="video"
              accept="video/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            Video <FaVideo />
          </label>
          <label>
            <input
              type="file"
              name="document"
              accept="application/pdf"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            File <FaFilePdf />
          </label>
        </div>
      )}
      <textarea
        type="text"
        value={messageText}
        onChange={(e) => dispatch(setMessageText(e.target.value))}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={`${
          isAds
            ? "Type a message & include your Phone Number"
            : "Type a message"
        }`}
        className="tw form-control h-[44px] input-box-input border p-2"
      />

      {sendingMsg || selectedFile ? ( // Show spinner for both text and file sending
        <Spinner size="sm" />
      ) : (
        <div className="hover:bg-blue ">
          <button
            onClick={(e) => handleSend(e, "user")}
            className="hover:bg-none"
          >
            <IoSend
              size={25}
              className="hover:text-white cursor-pointer  p-1  w-auto"
            />
          </button>
        </div>
      )}
      {isAdmin && selectedConvo?.postType == 3 && (
        <>
          {sendingMsg ? (
            <Spinner size="sm" />
          ) : (
            <button
              onClick={(e) => handleSend(e, "admin")}
              disabled={sendingMsg}
            >
              <IoSend size={25} style={{ cursor: "pointer", color: "red" }} />
            </button>
          )}
        </>
      )}
      <ThankYouModal
        show={thankYou}
        onHide={toggleModal}
        // totalPrice={totalPrice}
        state={{ chatPay: true }}
      />
    </div>
  );
}

export default MsgInputBox;
